import { observer } from 'mobx-react';
import * as React from 'react';

export const ContactUs = observer((props: {}) => (
  <div>
    <div className="center">
      <div className="cf">
        <div className="fl w-100">
          <p className="tc pv2 fw5 f2 bg_orange white">Contact Us</p>
        </div>
        <div className="fl w-100 pa2 ph7-l flex-ns">
          <div className="fl w-100 w-50-ns pa2">
            <section className="tc pa3 h-100">
              <article className="hide-child h-100 ba b--black-20 center">
                <div className="pa2 bt b--black-20">
                  <span className="f6 dark-blue bb">Prof. Dr. Quazi Billur Rahman</span>
                  <p className="f6 mv1">Secretary General</p>
                  <p className="f6 mv1">BAMOS</p>
                  <p className="f6 mv1">E-mail: bamos.office@gmail.com</p>
                </div>
              </article>
            </section>
          </div>
          <div className="fl w-100 w-50-ns pa2">
            <section className="tc pa3 h-100">
              <article className="hide-child h-100 ba b--black-20 center">
                <div className="pa2 bt b--black-20">
                  <span className="f6 dark-blue bb">Prof. Dr.Ismat Ara Haider Lita</span>
                  <p className="f6 mv1">Secretary</p>
                  <p className="f6 mv1">BCOMS 2018</p>
                  <p className="f6 mv1">E-mail: dr.ismat1965@gmail.com</p>
                </div>
              </article>
            </section>
          </div>
        </div>
        {/* <div className="fl w-100">
          <p className="tc pv2 b f4">Conference Committee</p>
        </div> */}
        <div className="fl w-100 pa2 pb4 ph7-l">
          <div className="fl w-100 flex-ns">
            <div className="fl w-100 w-50-ns pa2">
              <section className="tc pa3 h-100">
                <article className="hide-child h-100 ba b--black-20 center">
                  <div className="pa2 bt b--black-20">
                    <p className="f6 db dark-blue">Dr. Sk. Md. Jahidul Islam (Rousseau)</p>
                    <p className="f6 mv1">Chairman, Scientific Committee</p>
                    <p className="f6 mv1">Cell: +8801715348431</p>
                  </div>
                </article>
              </section>
            </div>
            <div className="fl w-100 w-50-ns pa2">
              <section className="tc pa3 h-100">
                <article className="hide-child h-100 ba b--black-20 center">
                  <div className="pa2 bt b--black-20">
                    <p className="f6 db dark-blue">Dr. Shaheen Ahmed</p>
                    <p className="f6 mv1">Co-Chairman, Scientific Committee</p>
                    <p className="f6 mv1">Cell: +8801718552433</p>
                  </div>
                </article>
              </section>
            </div>
          </div>
          <div className="fl w-100 flex-ns">
            <div className="fl w-100 w-50-ns pa2">
              <section className="tc pa3 h-100">
                <article className="hide-child h-100 ba b--black-20 center">
                  <div className="pa2 bt b--black-20">
                    <p className="f6 db dark-blue">Dr. Shyamol Nandi</p>
                    <p className="f6 mv1">Member Secretary, Scientific Committee</p>
                    <p className="f6 mv1">Cell: +8801911185373</p>
                  </div>
                </article>
              </section>
            </div>
            <div className="fl w-100 w-50-ns pa2">
              <section className="tc pa3 h-100">
                <article className="hide-child h-100 ba b--black-20 center">
                  <div className="pa2 bt b--black-20">
                    <p className="f6 db dark-blue">Dr. Mir Nowazesh Ali</p>
                    <p className="f6 mv1">International Affairs Secretary</p>
                    <p className="f6 mv1">BAMOS</p>
                    <p className="f6 mv1">Cell: +8801730000285</p>
                  </div>
                </article>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/ContactUs.tsx